import Drawer from 'components/Drawer/Drawer.component';
import Footer from 'components/Footer/Footer.component';
import { FooterMenuTheme } from 'components/Footer/Footer.helpers';
import Icon from 'components/Icon/Icon.component';
import MenuTabs from 'components/MenuTabs/MenuTabs.component';
import FeedbackIcon from 'images/icons/feedback-icon.svg';
import { useFeedbackFormOpener } from 'pages/dashboard/dashboard.hooks';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { ThemeProvider } from 'styled-components';
import { useCustomEvent } from 'utils/hooks/use-custom-event';
import { SlideInVariantProps } from '../SlideInMenu.type';
import {
  ButtonFooterMedallia,
  CompactTabList,
  CompactTabListLink,
  MedalliaFooter,
  MenuContent,
  SlideInContentWrapper,
  TextMedallia,
} from '../style/CompactSlideInMenu.style';
import CompactMenuHeader from './CompactMenuHeader.component';
import CompactTabContent from './CompactTabContent.component';

const domIdPrefix = 'compact-menu';

const SlideInCompactMenu = React.forwardRef<
  HTMLDivElement,
  SlideInVariantProps
>(function SlideInCompactMenu(
  { navbarContent, isOpen, activeTabIndex, drawerProps, onClickOutside },
  forwardedRef,
) {
  const openFeedbackForm = useFeedbackFormOpener();

  //we close the drawer so the user can see the contract modal
  useCustomEvent({
    eventName: 'downloadContractModal',
    onSignal() {
      if (onClickOutside) onClickOutside();
    },
  });

  return (
    <Drawer {...drawerProps} open={isOpen} enableOverlayUI={false}>
      <SlideInContentWrapper ref={forwardedRef}>
        <div>
          <CompactMenuHeader navbarContent={navbarContent} />
          <MenuContent>
            <MenuTabs
              domIdPrefix={domIdPrefix}
              menuTabList={navbarContent.menuTab}
              listComponent={CompactTabList}
              linkComponent={CompactTabListLink}
            />
            <CompactTabContent
              isActive={isOpen}
              navbarContent={navbarContent}
              activeTabIndex={activeTabIndex}
              domIdPrefix={domIdPrefix}
            />
          </MenuContent>
        </div>
        <div>
          <MedalliaFooter>
            <ButtonFooterMedallia onClick={openFeedbackForm}>
              <Icon
                iconSize="20.83px"
                iconHeight="19.79px"
                marginRight="14px"
                iconSrc={FeedbackIcon}
                fill="currentColor"
              />
              <TextMedallia>
                <Translate id="lbl.feedback"></Translate>
              </TextMedallia>
            </ButtonFooterMedallia>
          </MedalliaFooter>
        </div>
        <ThemeProvider theme={FooterMenuTheme}>
          <Footer isInsideDrawer />
        </ThemeProvider>
      </SlideInContentWrapper>
    </Drawer>
  );
});

export default SlideInCompactMenu;
